"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Importer = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
function createAuthUrl(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, source, redirectUrl, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            method: 'POST',
            endpoint: `${source}/authUrl`,
            body: { redirectUrl },
            workspaceId,
        });
    });
}
function getSession(_a) {
    return __awaiter(this, arguments, void 0, function* ({ source, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            endpoint: `${source}/session`,
        });
    });
}
function createSessionWithoutOAuth({ source, credentials, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.importer, {
        method: 'POST',
        endpoint: `${source}/session`,
        body: { credentials },
    });
}
function deleteSession({ source }) {
    return (0, request_1.airRequest)(types_1.EndpointType.importer, {
        method: 'DELETE',
        endpoint: `${source}/session`,
    });
}
function getFolder({ workspaceId, source, descriptor, cursor, pageSize, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.importer, {
        endpoint: `${source}/folder?${(0, util_1.formatParamsForHttp)({
            descriptor,
            cursor,
            pageSize,
        })}`,
        workspaceId,
    });
}
function createJob(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, source, files, folders, parentBoardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            method: 'POST',
            endpoint: `${source}/job`,
            body: { source, files, folders, parentBoardId },
            workspaceId,
            boardContext: parentBoardId,
        });
    });
}
function list(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, params, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            endpoint: `jobs/list?${(0, util_1.formatParamsForHttp)(params)}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function viewJob(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, importId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            endpoint: `jobs/detail/${importId}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function deleteJob(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, importId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.importer, {
            endpoint: `jobs/${importId}`,
            method: 'DELETE',
            workspaceId,
        });
    });
}
exports.Importer = {
    createAuthUrl,
    getSession,
    createJob,
    list,
    createSessionWithoutOAuth,
    deleteSession,
    getFolder,
    viewJob,
    deleteJob,
};
//# sourceMappingURL=importer.js.map